"use client";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { BorderedButton } from "../button/borderedButton";
import { ConfirmButton } from "../button/confirmButton";
import { usePathname } from "next/navigation";
import { clearCart, clearServiceCart } from "@/utils/cartUtils";
import CloseIcon from "../_icons/closeIcon";

export const ClearCartModal = ({
  isOpen,
  onRequestClose,
  merchantColor,
  addToCart,
}: any) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const pathname = usePathname();

  const isServicePage: boolean = pathname.includes("services");

  const handleCartClear = () => {
    if (isServicePage) {
      clearCart();
      global?.window?.localStorage.removeItem("giftCard");
    } else {
      clearServiceCart();
    }
    if (typeof addToCart === "function") {
      addToCart();
    }
    onRequestClose();
  };

  return (
    <ReactModal
      ariaHideApp={false}
      appElement={global?.window?.document?.getElementById("app") || undefined}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="fixed inset-0 flex items-center justify-center"
      overlayClassName="fixed inset-0 bg-black bg-opacity-75 z-50"
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-auto sm:w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-4">
          <h2 className="pt-4 sm:pt-0 text-4xl text-[32px] font-medium text-[#373737]">
            Your cart contains {isServicePage ? "retail items" : "services"}
          </h2>
          <button
            onClick={onRequestClose}
            className="text-gray-600 hover:text-gray-900"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="py-4 px-6">
          <p className="mb-4 text-[15px] text-md text-[#000000]">
            {`To add this ${
              !isServicePage ? "item" : "service"
            }, you'll need to either ${
              isServicePage ? "check out your items " : "book your appointment "
            }first or clear your cart.`}
          </p>
        </div>
        <div className="sm:static fixed bottom-0 left-0 w-full z-50 sm:z-auto">
          <div className="flex flex-col sm:flex-row justify-end gap-4 items-center px-4 py-4 max-w-md md:max-w-lg lg:max-w-xl mx-auto bg-white">
            <div className="w-full sm:w-auto">
              <BorderedButton
                style={{
                  color: merchantColor,
                  borderColor: merchantColor,
                }}
                className="w-full flex justify-center"
                onClick={handleCartClear}
              >
                Clear Cart
              </BorderedButton>
            </div>

            <ConfirmButton
              style={{
                backgroundColor: merchantColor,
              }}
              onClick={onRequestClose}
              className="w-full sm:w-auto h-auto text-white disabled:text-black py-2 rounded disabled:bg-[#E5E5E5]"
            >
              Go Back
            </ConfirmButton>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
